import { io } from "socket.io-client";
import Source from "../../Source";

// chzzk 채팅을 게이트웨이 릴레이로 수신 (event-stream / gateway).
//   본인 채널 OAuth 직결은 ChzzkDirectSource가 담당한다. 이 소스는 **chzzk_relay**(관리자: 남의 채널 읽기) 전용으로 사용한다.
//   relay:true → 게이트웨이가 owner OAuth 해석을 건너뛰고 **강제 Kimcore**(서버 네이버 세션쿠키)로 대상 채널에
//   시청자 입장해 공개 채팅을 끌어온다. Kimcore는 OAuth 토큰 refresh를 안 하므로 Edge direct와 refresh_token
//   회전 클로버가 없다 → 본인 chzzk(direct)와 chzzk_relay(이 소스) 공존 가능.
// stateless: open() 시 token+streamerAliasId(+_forceKimcore)로 startChatStream → server가 streamEvent 되쏨.
export default class ChzzkGatewaySource extends Source {
  constructor({ token, streamerAliasId, useMock = false, relay = false } = {}) {
    super({ provider: "chzzk_relay", kind: "event-stream", mode: "gateway" });
    this._token = token;
    this._streamerAliasId = streamerAliasId;
    this._useMock = useMock;
    this._relay = relay; // true면 게이트웨이가 강제 Kimcore(남의 채널)
    this._socket = null;
    this._onStatus = null;
  }

  // 채팅 스트림 오픈 결과(true)/실패(false) — 상태 아이콘용
  onStatus(cb) {
    this._onStatus = cb;
    return this;
  }

  open() {
    const socket = io(`${process.env.VUE_APP_GATEWAY_HOST_URL}/sub/event-stream/chzzk`, {
      transports: ["websocket"],
    });
    this._socket = socket;

    this._setStatus("connecting");
    this._watchGatewayHandshake(socket); // 핸드셰이크 연속 실패 → failed + 원인(E_5XX 등)
    socket.on("streamEvent", (event = {}) => this._emit(event));
    socket.on("commandResult", (data = {}) => {
      const msg = data.message;
      // 3-way: 성공(ready) / 오프라인(offline=채널은 있으나 방송중 아님) / 실패(failed=채널없음·에러)
      if (msg === "START_CHAT_STREAM_SUCCESS") this._setStatus("ready");
      else if (msg === "START_CHAT_STREAM_OFFLINE") this._setStatus("offline");
      else if (msg === "START_CHAT_STREAM_NOT_FOUND" || msg === "START_CHAT_STREAM_FAILED") this._setStatus("failed");
      if (!this._onStatus) return;
      this._onStatus(msg === "START_CHAT_STREAM_SUCCESS");
    });

    // connect(+재연결) 시 스트림 시작 요청. _forceKimcore면 서버가 owner OAuth 무시·강제 Kimcore.
    socket.on("connect", () => {
      socket.emit("startChatStream", {
        token: this._token,
        _streamerAliasId: this._streamerAliasId,
        _useMock: this._useMock,
        _forceKimcore: this._relay,
      });
    });

    return this;
  }

  close() {
    if (!this._socket) return;
    try {
      this._socket.emit("endChatStream", { _streamerAliasId: this._streamerAliasId, _useMock: this._useMock });
    } catch (error) {
      console.error(error);
    }
    this._socket.disconnect();
    this._socket = null;
  }
}
